import React from "react";
import PropTypes from "prop-types";
import { ErrorBoundaryIcon } from "../../icons";
import "./ErrorBoundary.scss";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error("[ErrorBoundary] Caught error:", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    if (this.props.onReset) {
      this.props.onReset();
    } else {
      window.location.href = "/";
    }
  };

  render() {
    if (this.state.hasError) {
      const { fallback } = this.props;

      if (fallback) return fallback;

      return (
        <div className="eb-root">
          <div className="eb-card">
            <div className="eb-icon">
              <ErrorBoundaryIcon size={48} />
            </div>
            <h2 className="eb-title">Something went wrong</h2>
            <p className="eb-message">
              {this.state.error?.message || "An unexpected error occurred."}
            </p>
            {process.env.NODE_ENV === "development" && this.state.errorInfo && (
              <details className="eb-details">
                <summary>Error details</summary>
                <pre>{this.state.errorInfo.componentStack}</pre>
              </details>
            )}
            <div className="eb-actions">
              <button className="eb-btn eb-btn--primary" onClick={this.handleReset}>
                Go to Home
              </button>
              <button className="eb-btn eb-btn--secondary" onClick={() => window.location.reload()}>
                Reload Page
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  onReset: PropTypes.func,
  fallback: PropTypes.node,
  children: PropTypes.node,
};

export default ErrorBoundary;
